export const storage = {
  hash: '@cov/hash',
  showPushCount: '@cov/showPushCount',
  showPushInfoAlert: '@cov/showPushInfoAlert',
  enabledInitCount: '@cov/enabledInitCount',
};
